const layoutConfig = {
    sidebar: {
        open: false,
        hide: true  //if true then sidebar will be expanded otherwise collapsed
        
    },
    header: {
        hide: true, //if true then header will not render at all
    },
    footer: {
        hide: true, //if true then footer will not render at all
    },
};
export default layoutConfig